import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { SearchInput } from '@gem/ui-kit';

import { WorkspaceMembersList } from '../../components/WorkspaceMembersList/WorkspaceMembersList';
import { useWorkspaceMembersPopupPresenter } from './WorkspaceMembersPopup.presenter';
import styles from './WorkspaceMembersPopup.styles.m.css';

export const WorkspaceMembersPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { popupInstance } = props;
  const { t } = useTranslation();
  const presenter = useWorkspaceMembersPopupPresenter(props);
  useClosePopupOnNavigation(popupInstance);

  return (
    <Popup
      title={t('org_members')}
      isOpened
      isHidden={popupInstance.isHidden}
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <SearchInput
        className={styles.search}
        placeholder={t('search_hint')}
        value={presenter.searchText}
        onChange={presenter.onSearch}
      />

      <WorkspaceMembersList
        searchText={presenter.searchText}
        isShowMemberMenu={true}
        onMemberClick={presenter.onMemberClick}
      />
    </Popup>
  );
});
